import React from 'react'

import getProductsBySelection from 'src/helpers/getProductsBySelection'

import styles from './ProductList.module.scss'
import ProductGrid from '../ProductGrid/ProductGrid'

type Props = {
  fields: any
  brand?: string
}

const ProductList = ({ fields, brand }: Props) => {
  const { selection } = fields
  const items = getProductsBySelection(selection, brand)
  if (items.length < 1) {
    return null
  }

  return (
    <div className={styles.productList}>
      <div className={styles.listHeading}>
        <h3 className={styles.title}>{fields.title}</h3>
      </div>
      <ProductGrid products={items.filter((product: any) => product.product !== fields.exclude).slice(0, 8)} />
    </div>
  )
}

export default ProductList
